import React, { useEffect, useRef, useState } from 'react';
import { Container } from './Dashboard.styles';
import KpiList from './KpiList/KpiList';
import TableView from './TableView';
import {
	Breadcrumbs,
	ContentWrapper,
	DateRangeWrapper,
	FilterWrapper,
} from './CategoryDashboard.styles';
import {
	filterSelectedOptions,
	transformFilterOptions,
} from '../MultisourceSkuData/MultisourceSkuData';
import MultiSelect from '../MultisourceSkuData/components/MultiSelect';
import {
	ApButtonMain,
	ApButtonText,
	ApLoaderDefault,
	ApLoaderText,
} from '@alixpartners/ui-components';
import {
	getCascadingSkuFiltersData,
	getDatesSKU,
	getDistinctSku,
	getModuleFilter,
} from 'utils/apiRequests';
import { isNull } from 'lodash';
import {
	getDateFormat,
	getDateRangeMonthYearSrc,
	getDateRangeMonthYearState,
} from 'CategoryManagement/utils';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';

const filterInitialOptions = {
	category_1: {
		options: [],
		selectedOption: [],
	},
	category_2: {
		options: [],
		selectedOption: [],
	},
	category_3: {
		options: [],
		selectedOption: [],
	},
	commodity_Code: {
		options: [],
		selectedOption: [],
	},
	commodity_Family: {
		options: [],
		selectedOption: [],
	},
	supplier_count: {
		options: [],
		selectedOption: [],
	},
	origin_Country: {
		options: [],
		selectedOption: [],
	},
	dateRange: {
		srcRange: '',
		stateRange: '',
	},
};
function createLabelValueArray() {
	const array = [];
	for (let i = 1; i <= 10; i++) {
		array.push({
			label: `> ${i}`,
			value: i,
		});
	}
	return array;
}
const payloadKeys = {
	category_1: 'category1',
	category_2: 'category2',
	category_3: 'category3',
	commodity_Code: 'commodityCode',
	commodity_Family: 'commodityFamily',
	origin_Country: 'originCountry',
};

const CategoryDashboard = ({ modelId, setContent, currencySymbol }) => {
	const [filterData, setFilterData] = useState(filterInitialOptions);
	const [defaultFilterData, setDefaultFilterData] = useState(
		filterInitialOptions
	);
	const [initialFilteredData, setInitialFilterData] = useState(
		filterInitialOptions
	);
	const [isClearedAllFilter, setIsClearedAllFilter] = useState(false);
	const [distinctSku, setDistinctSku] = useState([]);
	const [isFilterLoading, setIsFilterLoading] = useState(true);
	const [skuCteFilterModel, setSkuCteFilterModel] = useState({});
	const [isLoadingOptions, setIsLoadingOptions] = useState(false);
	const [isRenderingInitially, setIsRenderingInitially] = useState(1);
	const gridRef = useRef();

	const checkAndFormat = data => {
		return data?.filter(x => x !== null).map(x => {
			return { label: x, value: x };
		});
	};

	useEffect(() => {
		const supplierCountOptions = createLabelValueArray();
		const payload = {
			modelId: modelId,
		};

		const fetchData = async () => {
			try {
				const [filterResponse, dateResponse] = await Promise.all([
					getModuleFilter(payload),
					getDatesSKU(),
				]);

				if (filterResponse.succeeded && dateResponse.succeeded) {
					if (
						!isNull(filterResponse.data) &&
						Object.keys(filterResponse.data).length > 0
					) {
						const formatedCategory1Options = checkAndFormat(
							filterResponse.data.category1
						);
						const formatedCategory2Options = checkAndFormat(
							filterResponse.data.category2
						);
						const formatedCategory3Options = checkAndFormat(
							filterResponse.data.category3
						);
						const formatedCommodityCodeOptions = checkAndFormat(
							filterResponse.data.commodityCode
						);
						const formatedcommodityFamilyOptions = checkAndFormat(
							filterResponse.data.commodityFamily
						);
						const formatedCountryOriginOptions = checkAndFormat(
							filterResponse.data.originCountry
						);
						const minDate = dateResponse?.data?.minDate.split('T')[0];
						const maxDate = dateResponse?.data?.maxDate.split('T')[0];
						const wholeRange = getDateRangeMonthYearSrc(minDate, maxDate);
						const selectedRange = getDateRangeMonthYearState(minDate, maxDate);
						const defaultCategory1Selection =
							formatedCategory1Options.length > 0
								? [formatedCategory1Options[0]?.value]
								: [];
						const defaultCategory2Selection =
							formatedCategory2Options.length === 1
								? [formatedCategory2Options[0]?.value]
								: [];
						const defaultCategory3Selection =
							formatedCategory3Options.length === 1
								? [formatedCategory3Options[0]?.value]
								: [];
						const defaultCommodityCodeSelection =
							formatedCommodityCodeOptions.length === 1
								? [formatedCommodityCodeOptions[0]?.value]
								: [];
						const defaultCommodityFamilySelection =
							formatedcommodityFamilyOptions.length === 1
								? [formatedcommodityFamilyOptions[0]?.value]
								: [];

						const defaultCountryOriginSelection =
							formatedCountryOriginOptions.length === 1
								? [formatedCountryOriginOptions[0]?.value]
								: [];

						const filterDataToSet = {
							category_1: {
								options: formatedCategory1Options,
								selectedOption: defaultCategory1Selection,
							},
							category_2: {
								options: formatedCategory2Options,
								selectedOption: defaultCategory2Selection,
							},
							category_3: {
								options: formatedCategory3Options,
								selectedOption: defaultCategory3Selection,
							},
							commodity_Code: {
								options: formatedCommodityCodeOptions,
								selectedOption: defaultCommodityCodeSelection,
							},
							commodity_Family: {
								options: formatedcommodityFamilyOptions,
								selectedOption: defaultCommodityFamilySelection,
							},
							supplier_count: {
								options: supplierCountOptions,
								selectedOption: [1],
							},
							origin_Country: {
								options: formatedCountryOriginOptions,
								selectedOption: defaultCountryOriginSelection,
							},
							dateRange: {
								srcRange: wholeRange,
								stateRange: selectedRange,
							},
						};

						setFilterData(filterDataToSet);

						if (defaultCategory1Selection.length > 0) {
							const newFilters = {
								filtersDto: {
									category1: defaultCategory1Selection,
									category2: defaultCategory2Selection,
									category3: defaultCategory3Selection,
									commodityCode: defaultCommodityCodeSelection,
									commodity_Family: defaultCommodityFamilySelection,
									origin_Country: defaultCountryOriginSelection,
								},
								ModelId: modelId,
							};

							setIsLoadingOptions(true);
							const optionsData = await getOptions(newFilters);
							setIsLoadingOptions(false);

							if (optionsData) {
								const newCategory2Options = checkAndFormat(
									optionsData.category2
								);
								const newCategory3Options = checkAndFormat(
									optionsData.category3
								);
								const newCommodityCodeOptions = checkAndFormat(
									optionsData.commodityCode
								);
								const newCommodityFamilyOptions = checkAndFormat(
									optionsData.commodityFamily
								);
								const newOriginCountryOptions = checkAndFormat(
									optionsData.originCountry
								);

								setFilterData(prevState => ({
									...prevState,
									category_2: {
										options: newCategory2Options,
										selectedOption:
											newCategory2Options.length === 1
												? newCategory2Options.map(x => x.value)
												: [],
									},
									category_3: {
										options: newCategory3Options,
										selectedOption:
											newCategory3Options.length === 1
												? newCategory3Options.map(x => x.value)
												: [],
									},
									commodity_Code: {
										options: newCommodityCodeOptions,
										selectedOption:
											newCommodityCodeOptions.length === 1
												? newCommodityCodeOptions.map(x => x.value)
												: [],
									},
									commodity_Family: {
										options: newCommodityFamilyOptions,
										selectedOption:
											newCommodityFamilyOptions.length === 1
												? newCommodityFamilyOptions.map(x => x.value)
												: [],
									},
									origin_Country: {
										options: newOriginCountryOptions,
										selectedOption:
											newOriginCountryOptions.length === 1
												? newOriginCountryOptions.map(x => x.value)
												: [],
									},
								}));
							}
						}

						setInitialFilterData({
							...filterDataToSet,
							category_1: {
								...filterDataToSet.category_1,
								selectedOption: formatedCategory1Options.map(x => x?.value),
							},
							category_2: {
								...filterDataToSet.category_2,
								selectedOption: formatedCategory2Options.map(x => x?.value),
							},
							category_3: {
								...filterDataToSet.category_3,
								selectedOption: formatedCategory3Options.map(x => x?.value),
							},
							commodity_Code: {
								...filterDataToSet.commodity_Code,
								selectedOption: formatedCommodityCodeOptions.map(x => x?.value),
							},
							commodity_Family: {
								...filterDataToSet.commodity_Family,
								selectedOption: formatedcommodityFamilyOptions.map(
									x => x?.value
								),
							},
							origin_Country: {
								...filterDataToSet.origin_Country,
								selectedOption: formatedCountryOriginOptions.map(x => x?.value),
							},
						});

						setDefaultFilterData(filterDataToSet);
						const { dateFrom, dateTo } = getDateFormat(
							filterDataToSet.dateRange.stateRange
						);
						const distinctSKUpayload = {
							filtersDto: {
								category1: defaultCategory1Selection,
								category2: defaultCategory2Selection,
								category3: defaultCategory3Selection,
								commodityCode: defaultCommodityCodeSelection,
								commodityFamily: defaultCommodityFamilySelection,
								originCountry: defaultCountryOriginSelection,
							},
							modelId: modelId,
							startDate: dateFrom,
							endDate: dateTo,
							supplierCount: Math.max(
								...filterDataToSet.supplier_count.selectedOption
							),
						};
						getDistinctSku(distinctSKUpayload).then(response =>
							setDistinctSku(response.data.sku)
						);

						const mergedFiltersData = transformForSkuCteFilterModel(
							filterDataToSet
						);
						setSkuCteFilterModel(mergedFiltersData);
						setIsFilterLoading(false);
					}
				}
			} catch (error) {
				console.error('Failed to initialize filters:', error);
				setIsFilterLoading(false);
			}
		};

		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getOptions = async filtersDto => {
		const response = await getCascadingSkuFiltersData(filtersDto);
		if (response.succeeded) {
			if (!isNull(response.data)) {
				if (Object.keys(response.data).length > 0) {
					return response.data;
				}
			}
		}
		return null;
	};

	const onDateRangeChangeHandler = event => {
		setIsClearedAllFilter(false);

		setFilterData(prevState => ({
			...prevState,
			dateRange: {
				...prevState.dateRange,
				stateRange: event,
			},
		}));
	};

	const onFilterChangeHandler = (key, value) => {
		setIsClearedAllFilter(false);
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
	};

	const onCategory1ChangeHandler = async (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
		setIsClearedAllFilter(false);
		const newFilters = {
			filtersDto: {
				category1: value,
				category2: filterData?.category_2?.selectedOption,
				category3: filterData?.category_3?.selectedOption,
				commodityCode: filterData?.commodity_Code?.selectedOption,
				commodityFamily: filterData?.commodity_Family?.selectedOption,
				originCountry: filterData?.origin_Country?.selectedOption,
				[payloadKeys[key]]: value,
			},
			ModelId: modelId,
		};
		setIsLoadingOptions(true);
		const optionsData = await getOptions(newFilters);
		const formatedCategory1Options = checkAndFormat(optionsData.category1);
		const formatedCategory2Options = checkAndFormat(optionsData.category2);
		const formatedCategory3Options = checkAndFormat(optionsData.category3);
		const formatedCommodityCodeOptions = checkAndFormat(
			optionsData.commodityCode
		);
		const formatedCommodityFamilyOptions = checkAndFormat(
			optionsData.commodityFamily
		);
		const formatedOriginCountryOptions = checkAndFormat(
			optionsData.originCountry
		);
		setFilterData(prevState => ({
			...prevState,
			category_1: {
				options: formatedCategory1Options,
				selectedOption:
					formatedCategory1Options.length === 1
						? formatedCategory1Options.map(x => x.value)
						: prevState.category_1.selectedOption.filter(selected =>
								formatedCategory1Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_2: {
				options: formatedCategory2Options,
				selectedOption:
					formatedCategory2Options.length === 1
						? formatedCategory2Options.map(x => x.value)
						: prevState.category_2.selectedOption.filter(selected =>
								formatedCategory2Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_3: {
				options: formatedCategory3Options,
				selectedOption:
					formatedCategory3Options.length === 1
						? formatedCategory3Options.map(x => x.value)
						: prevState.category_3.selectedOption.filter(selected =>
								formatedCategory3Options.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Code: {
				options: formatedCommodityCodeOptions,
				selectedOption:
					formatedCommodityCodeOptions.length === 1
						? formatedCommodityCodeOptions.map(x => x.value)
						: prevState.commodity_Code.selectedOption.filter(selected =>
								formatedCommodityCodeOptions.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Family: {
				options: formatedCommodityFamilyOptions,
				selectedOption:
					formatedCommodityFamilyOptions.length === 1
						? formatedCommodityFamilyOptions.map(x => x.value)
						: prevState.commodity_Family.selectedOption.filter(selected =>
								formatedCommodityFamilyOptions.some(
									option => option.value === selected
								)
						  ),
			},
			origin_Country: {
				options: formatedOriginCountryOptions,
				selectedOption:
					formatedOriginCountryOptions.length === 1
						? formatedOriginCountryOptions.map(x => x.value)
						: prevState.origin_Country.selectedOption.filter(selected =>
								formatedOriginCountryOptions.some(
									option => option.value === selected
								)
						  ),
			},
		}));
		setIsLoadingOptions(false);
	};

	const onCategory2ChangeHandler = async (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
		setIsClearedAllFilter(false);
		const newFilters = {
			filtersDto: {
				category1: filterData?.category_1?.selectedOption,
				category2: value,
				category3: filterData?.category_3?.selectedOption,
				commodityCode: filterData?.commodity_Code?.selectedOption,
				commodityFamily: filterData?.commodity_Family?.selectedOption,
				originCountry: filterData?.origin_Country?.selectedOption,
				[payloadKeys[key]]: value,
			},
			ModelId: modelId,
		};

		setIsLoadingOptions(true);
		const optionsData = await getOptions(newFilters);
		const formatedCategory1Options = checkAndFormat(optionsData.category1);
		const formatedCategory2Options = checkAndFormat(optionsData.category2);
		const formatedCategory3Options = checkAndFormat(optionsData.category3);
		const formatedCommodityCodeOptions = checkAndFormat(
			optionsData.commodityCode
		);
		const formatedCommodityFamilyOptions = checkAndFormat(
			optionsData.commodityFamily
		);
		const formatedOriginCountryOptions = checkAndFormat(
			optionsData.originCountry
		);
		setFilterData(prevState => ({
			...prevState,
			category_1: {
				options: formatedCategory1Options,
				selectedOption:
					formatedCategory1Options.length === 1
						? formatedCategory1Options.map(x => x.value)
						: prevState.category_1.selectedOption.filter(selected =>
								formatedCategory1Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_2: {
				options: formatedCategory2Options,
				selectedOption:
					formatedCategory2Options.length === 1
						? formatedCategory2Options.map(x => x.value)
						: prevState.category_2.selectedOption.filter(selected =>
								formatedCategory2Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_3: {
				options: formatedCategory3Options,
				selectedOption:
					formatedCategory3Options.length === 1
						? formatedCategory3Options.map(x => x.value)
						: prevState.category_3.selectedOption.filter(selected =>
								formatedCategory3Options.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Code: {
				options: formatedCommodityCodeOptions,
				selectedOption:
					formatedCommodityCodeOptions.length === 1
						? formatedCommodityCodeOptions.map(x => x.value)
						: prevState.commodity_Code.selectedOption.filter(selected =>
								formatedCommodityCodeOptions.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Family: {
				options: formatedCommodityFamilyOptions,
				selectedOption:
					formatedCommodityCodeOptions.length === 1
						? formatedCommodityCodeOptions.map(x => x.value)
						: prevState.commodity_Code.selectedOption.filter(selected =>
								formatedCommodityCodeOptions.some(
									option => option.value === selected
								)
						  ),
			},
			origin_Country: {
				options: formatedOriginCountryOptions,
				selectedOption:
					formatedOriginCountryOptions.length === 1
						? formatedOriginCountryOptions.map(x => x.value)
						: prevState.origin_Country.selectedOption.filter(selected =>
								formatedOriginCountryOptions.some(
									option => option.value === selected
								)
						  ),
			},
		}));
		setIsLoadingOptions(false);
	};

	const onCategory3ChangeHandler = async (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
		setIsClearedAllFilter(false);
		const newFilters = {
			filtersDto: {
				category1: filterData.category_1.selectedOption,
				category2: filterData.category_2.selectedOption,
				category3: value,
				commodityCode: filterData?.commodity_Code?.selectedOption,
				commodityFamily: filterData?.commodity_Family?.selectedOption,
				originCountry: filterData?.origin_Country?.selectedOption,
				[payloadKeys[key]]: value,
			},
			ModelId: modelId,
		};
		setIsLoadingOptions(true);
		const optionsData = await getOptions(newFilters);
		const formatedCategory1Options = checkAndFormat(optionsData.category1);
		const formatedCategory2Options = checkAndFormat(optionsData.category2);
		const formatedCategory3Options = checkAndFormat(optionsData.category3);
		const formatedCommodityCodeOptions = checkAndFormat(
			optionsData.commodityCode
		);
		const formatedCommodityFamilyOptions = checkAndFormat(
			optionsData.commodityFamily
		);
		const formatedOriginCountryOptions = checkAndFormat(
			optionsData.originCountry
		);
		setFilterData(prevState => ({
			...prevState,
			category_1: {
				options: formatedCategory1Options,
				selectedOption:
					formatedCategory1Options.length === 1
						? formatedCategory1Options.map(x => x.value)
						: prevState.category_1.selectedOption.filter(selected =>
								formatedCategory1Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_2: {
				options: formatedCategory2Options,
				selectedOption:
					formatedCategory2Options.length === 1
						? formatedCategory2Options.map(x => x.value)
						: prevState.category_2.selectedOption.filter(selected =>
								formatedCategory2Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_3: {
				options: formatedCategory3Options,
				selectedOption:
					formatedCategory3Options.length === 1
						? formatedCategory3Options.map(x => x.value)
						: prevState.category_3.selectedOption.filter(selected =>
								formatedCategory3Options.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Code: {
				options: formatedCommodityCodeOptions,
				selectedOption:
					formatedCommodityCodeOptions.length === 1
						? formatedCommodityCodeOptions.map(x => x.value)
						: prevState.commodity_Code.selectedOption.filter(selected =>
								formatedCommodityCodeOptions.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Family: {
				options: formatedCommodityFamilyOptions,
				selectedOption:
					formatedCommodityFamilyOptions.length === 1
						? formatedCommodityFamilyOptions.map(x => x.value)
						: prevState.commodity_Family.selectedOption.filter(selected =>
								formatedCommodityFamilyOptions.some(
									option => option.value === selected
								)
						  ),
			},
			origin_Country: {
				options: formatedOriginCountryOptions,
				selectedOption:
					formatedOriginCountryOptions.length === 1
						? formatedOriginCountryOptions.map(x => x.value)
						: prevState.origin_Country.selectedOption.filter(selected =>
								formatedOriginCountryOptions.some(
									option => option.value === selected
								)
						  ),
			},
		}));
		setIsLoadingOptions(false);
	};

	const onCommodityCodeChangeHandler = async (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
		setIsClearedAllFilter(false);
		const newFilters = {
			filtersDto: {
				category1: filterData.category_1.selectedOption,
				category2: filterData.category_2.selectedOption,
				category3: filterData.category_3.selectedOption,
				commodityCode: value,
				commodityFamily: filterData?.commodity_Family?.selectedOption,
				originCountry: filterData?.origin_Country?.selectedOption,
				[payloadKeys[key]]: value,
			},
			ModelId: modelId,
		};
		setIsLoadingOptions(true);
		const optionsData = await getOptions(newFilters);
		const formatedCategory1Options = checkAndFormat(optionsData.category1);
		const formatedCategory2Options = checkAndFormat(optionsData.category2);
		const formatedCategory3Options = checkAndFormat(optionsData.category3);
		const formatedCommodityCodeOptions = checkAndFormat(
			optionsData.commodityCode
		);
		const formatedCommodityFamilyOptions = checkAndFormat(
			optionsData.commodityFamily
		);
		const formatedOriginCountryOptions = checkAndFormat(
			optionsData.originCountry
		);
		setFilterData(prevState => ({
			...prevState,
			category_1: {
				options: formatedCategory1Options,
				selectedOption:
					formatedCategory1Options.length === 1
						? formatedCategory1Options.map(x => x.value)
						: prevState.category_1.selectedOption.filter(selected =>
								formatedCategory1Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_2: {
				options: formatedCategory2Options,
				selectedOption:
					formatedCategory2Options.length === 1
						? formatedCategory2Options.map(x => x.value)
						: prevState.category_2.selectedOption.filter(selected =>
								formatedCategory2Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_3: {
				options: formatedCategory3Options,
				selectedOption:
					formatedCategory3Options.length === 1
						? formatedCategory3Options.map(x => x.value)
						: prevState.category_3.selectedOption.filter(selected =>
								formatedCategory3Options.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Code: {
				options: formatedCommodityCodeOptions,
				selectedOption:
					formatedCommodityCodeOptions.length === 1
						? formatedCommodityCodeOptions.map(x => x.value)
						: prevState.commodity_Code.selectedOption.filter(selected =>
								formatedCommodityCodeOptions.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Family: {
				...prevState.commodity_Family,
				options: formatedCommodityFamilyOptions,
				selectedOption:
					formatedCommodityFamilyOptions.length === 1
						? formatedCommodityFamilyOptions.map(x => x.value)
						: prevState.commodity_Family.selectedOption.filter(selected =>
								formatedCommodityFamilyOptions.some(
									option => option.value === selected
								)
						  ),
			},
			origin_Country: {
				options: formatedOriginCountryOptions,
				selectedOption:
					formatedOriginCountryOptions.length === 1
						? formatedOriginCountryOptions.map(x => x.value)
						: prevState.origin_Country.selectedOption.filter(selected =>
								formatedOriginCountryOptions.some(
									option => option.value === selected
								)
						  ),
			},
		}));
		setIsLoadingOptions(false);
	};

	const onCommodityFamilyChangeHandler = async (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
		setIsClearedAllFilter(false);
		const newFilters = {
			filtersDto: {
				category1: filterData.category_1.selectedOption,
				category2: filterData.category_2.selectedOption,
				category3: filterData.category_3.selectedOption,
				commodityCode: filterData.commodity_Code.selectedOption,
				commodityFamily: value,
				originCountry: filterData?.origin_Country?.selectedOption,
				[payloadKeys[key]]: value,
			},
			ModelId: modelId,
		};
		setIsLoadingOptions(true);
		const optionsData = await getOptions(newFilters);
		const formatedCategory1Options = checkAndFormat(optionsData.category1);
		const formatedCategory2Options = checkAndFormat(optionsData.category2);
		const formatedCategory3Options = checkAndFormat(optionsData.category3);
		const formatedCommodityCodeOptions = checkAndFormat(
			optionsData.commodityCode
		);
		const formatedCommodityFamilyOptions = checkAndFormat(
			optionsData.commodityFamily
		);
		const formatedOriginCountryOptions = checkAndFormat(
			optionsData.originCountry
		);
		setFilterData(prevState => ({
			...prevState,
			category_1: {
				options: formatedCategory1Options,
				selectedOption:
					formatedCategory1Options.length === 1
						? formatedCategory1Options.map(x => x.value)
						: prevState.category_1.selectedOption.filter(selected =>
								formatedCategory1Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_2: {
				options: formatedCategory2Options,
				selectedOption:
					formatedCategory2Options.length === 1
						? formatedCategory2Options.map(x => x.value)
						: prevState.category_2.selectedOption.filter(selected =>
								formatedCategory2Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_3: {
				options: formatedCategory3Options,
				selectedOption:
					formatedCategory3Options.length === 1
						? formatedCategory3Options.map(x => x.value)
						: prevState.category_3.selectedOption.filter(selected =>
								formatedCategory3Options.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Code: {
				options: formatedCommodityCodeOptions,
				selectedOption:
					formatedCommodityCodeOptions.length === 1
						? formatedCommodityCodeOptions.map(x => x.value)
						: prevState.commodity_Code.selectedOption.filter(selected =>
								formatedCommodityCodeOptions.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Family: {
				options: formatedCommodityFamilyOptions,
				selectedOption:
					formatedCommodityFamilyOptions.length === 1
						? formatedCommodityFamilyOptions.map(x => x.value)
						: prevState.commodity_Family.selectedOption.filter(selected =>
								formatedCommodityFamilyOptions.some(
									option => option.value === selected
								)
						  ),
			},
			origin_Country: {
				options: formatedOriginCountryOptions,
				selectedOption:
					formatedOriginCountryOptions.length === 1
						? formatedOriginCountryOptions.map(x => x.value)
						: prevState.origin_Country.selectedOption.filter(selected =>
								formatedOriginCountryOptions.some(
									option => option.value === selected
								)
						  ),
			},
		}));
		setIsLoadingOptions(false);
	};

	const onOriginCountryChangeHandler = async (key, value) => {
		setFilterData(prevState => ({
			...prevState,
			[key]: {
				...prevState[key],
				selectedOption: value,
			},
		}));
		setIsClearedAllFilter(false);
		const newFilters = {
			filtersDto: {
				category1: filterData.category_1.selectedOption,
				category2: filterData.category_2.selectedOption,
				category3: filterData.category_3.selectedOption,
				commodityCode: filterData.commodity_Code.selectedOption,
				commodityFamily: filterData.commodity_Family.selectedOption,
				originCountry: value,
				[payloadKeys[key]]: value,
			},
			ModelId: modelId,
		};
		setIsLoadingOptions(true);
		const optionsData = await getOptions(newFilters);
		const formatedCategory1Options = checkAndFormat(optionsData.category1);
		const formatedCategory2Options = checkAndFormat(optionsData.category2);
		const formatedCategory3Options = checkAndFormat(optionsData.category3);
		const formatedCommodityCodeOptions = checkAndFormat(
			optionsData.commodityCode
		);
		const formatedCommodityFamilyOptions = checkAndFormat(
			optionsData.commodityFamily
		);
		const formatedCountryOriginOptions = checkAndFormat(
			optionsData.originCountry
		);
		setFilterData(prevState => ({
			...prevState,
			category_1: {
				options: formatedCategory1Options,
				selectedOption:
					formatedCategory1Options.length === 1
						? formatedCategory1Options.map(x => x.value)
						: prevState.category_1.selectedOption.filter(selected =>
								formatedCategory1Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_2: {
				options: formatedCategory2Options,
				selectedOption:
					formatedCategory2Options.length === 1
						? formatedCategory2Options.map(x => x.value)
						: prevState.category_2.selectedOption.filter(selected =>
								formatedCategory2Options.some(
									option => option.value === selected
								)
						  ),
			},
			category_3: {
				options: formatedCategory3Options,
				selectedOption:
					formatedCategory3Options.length === 1
						? formatedCategory3Options.map(x => x.value)
						: prevState.category_3.selectedOption.filter(selected =>
								formatedCategory3Options.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Code: {
				options: formatedCommodityCodeOptions,
				selectedOption:
					formatedCommodityCodeOptions.length === 1
						? formatedCommodityCodeOptions.map(x => x.value)
						: prevState.commodity_Code.selectedOption.filter(selected =>
								formatedCommodityCodeOptions.some(
									option => option.value === selected
								)
						  ),
			},
			commodity_Family: {
				...prevState.commodity_Family,
				options: formatedCommodityFamilyOptions,
				selectedOption:
					formatedCommodityFamilyOptions.length === 1
						? formatedCommodityFamilyOptions.map(x => x.value)
						: prevState.commodity_Family.selectedOption.filter(selected =>
								formatedCommodityFamilyOptions.some(
									option => option.value === selected
								)
						  ),
			},
			origin_Country: {
				...prevState.origin_Country,
				options: formatedCountryOriginOptions,
				selectedOption:
					formatedCountryOriginOptions.length === 1
						? formatedCountryOriginOptions.map(x => x.value)
						: prevState.origin_Country.selectedOption.filter(selected =>
								formatedCountryOriginOptions.some(
									option => option.value === selected
								)
						  ),
			},
		}));
		setIsLoadingOptions(false);
	};

	const onFilterApplyHandler = () => {
		let mergedFiltersData;
		if (isClearedAllFilter) {
			mergedFiltersData = transformForSkuCteFilterModel(initialFilteredData);
		} else {
			const newFiltersData = {
				...filterData,
				category_1: {
					options: filterData.category_1.options,
					selectedOption: filterData?.category_1?.selectedOption,
				},
				category_2: {
					options: filterData.category_2.options,
					selectedOption: filterData?.category_2?.selectedOption,
				},
				category_3: {
					options: filterData.category_3.options,
					selectedOption: filterData?.category_3?.selectedOption,
				},
				commodity_Code: {
					options: filterData.commodity_Code.options,
					selectedOption: filterData?.commodity_Code?.selectedOption,
				},
				commodity_Family: {
					options: filterData.commodity_Family.options,
					selectedOption: filterData?.commodity_Family?.selectedOption,
				},
				origin_Country: {
					options: filterData.origin_Country.options,
					selectedOption: filterData?.origin_Country?.selectedOption,
				},
			};

			setDefaultFilterData(newFiltersData);
			mergedFiltersData = transformForSkuCteFilterModel(newFiltersData);
		}
		setSkuCteFilterModel(mergedFiltersData);
		if (isRenderingInitially) {
			setIsRenderingInitially(isRenderingInitially + 1);
		}
	};

	const onClearFiltersHandler = async () => {
		const newFilters = {
			filtersDto: {
				category1: [],
			},
			ModelId: modelId,
		};
		setIsLoadingOptions(true);
		try {
			const optionsData = await getOptions(newFilters);
			if (optionsData) {
				const formatedCategory1Options = checkAndFormat(optionsData.category1);
				const formatedCategory2Options = checkAndFormat(optionsData.category2);
				const formatedCategory3Options = checkAndFormat(optionsData.category3);
				const formatedCommodityCodeOptions = checkAndFormat(
					optionsData.commodityCode
				);
				const formatedCommodityFamilyOptions = checkAndFormat(
					optionsData.commodityFamily
				);
				const formatedOriginCountryOptions = checkAndFormat(
					optionsData.originCountry
				);
				setFilterData(prevState => ({
					...prevState,
					category_1: {
						options: formatedCategory1Options,
						selectedOption:
							formatedCategory1Options.length === 1
								? formatedCategory1Options.map(x => x?.value)
								: [],
					},
					category_2: {
						options: formatedCategory2Options,
						selectedOption:
							formatedCategory2Options.length === 1
								? formatedCategory2Options.map(x => x?.value)
								: [],
					},
					category_3: {
						options: formatedCategory3Options,
						selectedOption:
							formatedCategory3Options.length === 1
								? formatedCategory3Options.map(x => x?.value)
								: [],
					},
					commodity_Code: {
						options: formatedCommodityCodeOptions,
						selectedOption:
							formatedCommodityCodeOptions.length === 1
								? formatedCommodityCodeOptions.map(x => x?.value)
								: [],
					},
					commodity_Family: {
						options: formatedCommodityFamilyOptions,
						selectedOption:
							formatedCommodityFamilyOptions.length === 1
								? formatedCommodityFamilyOptions.map(x => x?.value)
								: [],
					},
					origin_Country: {
						options: formatedOriginCountryOptions,
						selectedOption:
							formatedOriginCountryOptions.length === 1
								? formatedOriginCountryOptions.map(x => x?.value)
								: [],
					},
					supplier_count: {
						options: createLabelValueArray(),
						selectedOption: [0],
					},
					dateRange: initialFilteredData?.dateRange,
				}));
				setIsClearedAllFilter(true);
			}
		} catch (error) {
			console.error('Failed to get options:', error);
		}
		setIsLoadingOptions(false);
	};

	const transformForSkuCteFilterModel = filterData => {
		const filtersApplied = filterSelectedOptions(filterData);
		const filterModelData = transformFilterOptions(filtersApplied);
		// const mergedFiltersData = mergeFilters(filterModelData, filtersForTable);
		return filterModelData;
	};

	const Loading = () => <ApLoaderDefault loaderText={() => <ApLoaderText />} />;

	return (
		<ContentWrapper>
			{false ? (
				<div style={{ marginTop: '150px' }}>
					<Loading />
				</div>
			) : (
				<>
					<Breadcrumbs>
						<span onClick={() => setContent(0)}>Segmented Data</span>&nbsp;/&nbsp;<span
						>
							Dashboard
						</span>
					</Breadcrumbs>
					{isFilterLoading ? (
						<Loading />
					) : (
						<FilterWrapper>
							<MultiSelect
								name="category_1"
								label="Category 1"
								options={filterData.category_1.options}
								selected={filterData.category_1.selectedOption}
								isLoading={isLoadingOptions}
								onChange={v => {
									onCategory1ChangeHandler('category_1', v);
								}}
								disabled={filterData.category_1.options.length === 0}
							/>

							<MultiSelect
								name="category_2"
								label="Category 2"
								options={filterData.category_2.options}
								selected={filterData.category_2.selectedOption}
								isLoading={isLoadingOptions}
								onChange={v => {
									onCategory2ChangeHandler('category_2', v);
								}}
								disabled={filterData.category_2.options.length === 0}
							/>
							<MultiSelect
								name="category_3"
								label="Category 3"
								options={filterData.category_3.options}
								selected={filterData.category_3.selectedOption}
								isLoading={isLoadingOptions}
								onChange={v => {
									onCategory3ChangeHandler('category_3', v);
								}}
								disabled={filterData.category_3.options.length === 0}
							/>
							<MultiSelect
								name="commodity_code"
								label="Commodity Code"
								options={filterData.commodity_Code.options}
								selected={filterData.commodity_Code.selectedOption}
								isLoading={isLoadingOptions}
								onChange={v => {
									onCommodityCodeChangeHandler('commodity_Code', v);
								}}
								disabled={filterData.commodity_Code.options.length === 0}
							/>
							<MultiSelect
								name="commodity_family"
								label="Commodity Family"
								options={filterData.commodity_Family.options}
								selected={filterData.commodity_Family.selectedOption}
								isLoading={isLoadingOptions}
								onChange={v => {
									onCommodityFamilyChangeHandler('commodity_Family', v);
								}}
								disabled={filterData.commodity_Family.options.length === 0}
							/>
							<MultiSelect
								name="origin_Country"
								label="Origin Country"
								options={filterData.origin_Country.options}
								selected={filterData.origin_Country.selectedOption}
								isLoading={isLoadingOptions}
								onChange={v => {
									onOriginCountryChangeHandler('origin_Country', v);
								}}
								disabled={filterData.origin_Country.options.length === 0}
							/>
							<MultiSelect
								name="supplier_count"
								label="Supplier Threshold"
								options={filterData.supplier_count.options}
								selected={
									filterData.supplier_count.selectedOption[0] !== 0 &&
									filterData.supplier_count.selectedOption
								}
								onChange={v => {
									onFilterChangeHandler('supplier_count', v);
								}}
							/>
							<DateRangeWrapper>
								<MonthPicker
									srcRange={
										isClearedAllFilter
											? initialFilteredData.dateRange.srcRange
											: filterData.dateRange.srcRange
									}
									stateRange={
										isClearedAllFilter
											? initialFilteredData.dateRange.stateRange
											: filterData.dateRange.stateRange
									}
									onConfirm={e => {
										onDateRangeChangeHandler(e);
									}}
								/>
							</DateRangeWrapper>
							<ApButtonMain onClick={onFilterApplyHandler} small>
								Apply Filters
							</ApButtonMain>
							<ApButtonText onClick={onClearFiltersHandler} small>
								Clear Filters
							</ApButtonText>
						</FilterWrapper>
					)}

					<Container>
						{!isFilterLoading && (
							<KpiList
								modelId={modelId}
								filterData={
									isClearedAllFilter ? initialFilteredData : filterData
								}
								counterToTriggerKPI={isRenderingInitially}
								currencySymbol={currencySymbol}
							/>
						)}
					</Container>

					{!isFilterLoading &&
						Object.keys(skuCteFilterModel).length !== 0 && (
							<TableView
								gridRef={gridRef}
								content={modelId}
								filterData={filterData}
								skuCteFilterModel={skuCteFilterModel}
								isRenderingInitially={isRenderingInitially}
								currencySymbol={currencySymbol}
								distinctSku={distinctSku}
							/>
						)}
				</>
			)}
		</ContentWrapper>
	);
};

export default CategoryDashboard;
